import AnchorBlock from './AnchorBlock';

export default AnchorBlock;
